import { MutationTree } from "vuex";
import ProcessUser from "@/types/documents/process/ProcessUser";
import { IDataProvider } from "@/store";
import { IProcessUserState } from "@/store/modules/processUser/state";

export enum ProcessUserMutations {
  SET_ONE = "SET_ONE_PROCESS_USER",
  SET_ALL = "SET_ALL_PROCESS_USER",
  SET_LAZY_DATA = "SET_LAZY_DATA_PROCESS_USER",
}

export const mutations: MutationTree<IProcessUserState> = {
  [ProcessUserMutations.SET_ONE](state, payload: ProcessUser) {
    state.processUser = payload;
  },
  [ProcessUserMutations.SET_ALL](state, payload: ProcessUser[]) {
    state.processUsers = payload;
  },
  [ProcessUserMutations.SET_LAZY_DATA](
    state,
    payload: IDataProvider<ProcessUser>
  ) {
    state.dataProvider = payload;
  },
};
